import { Box, Typography } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

const ComingSoon = ({ label }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5, py: 6 }}>
    <HourglassEmptyIcon sx={{ fontSize: 40, color: "text.disabled" }} />
    <Typography variant="body1" fontWeight={500} color="text.secondary">
      {label} module coming soon
    </Typography>
  </Box>
);

export default ComingSoon;